import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=fca29e44&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
import style0 from "../_layout.css?vue&type=style&index=0&id=fca29e44&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca29e44",
  null
  
)

export default component.exports